





















import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { http as _http } from '@/shared/https';
import TrackerContainer from './TrackerContainer.vue';
import { Locales } from "@/i18n/locales";

const namespace: string = "tracker";

@Component({
  components: {
      VJsonschemaForm,
      TrackerContainer
  }
})
export default class TrackerForm extends Vue {

    @Prop() data!: any;
    @Prop() template!: any;
    @Prop() selectedKey!: any;
    @Prop() editable!: boolean;
    @Prop() isDirty!: boolean;
    @Action("showLoading", {namespace:"application"} ) showLoading: any;
    @Action("hideLoading", {namespace:"application"} ) hideLoading: any;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("_appUserId", { namespace: "RootApp" } ) _userid!: number;
    
    formValid: boolean = false;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    get options() {
        return {
        "user": this._userid,
        "username": this._username,
        "locale": this.defaultLocale
        }
    }

    get subSchema() {
        return this.template.properties[this.selectedKey];
    }

    /** set is-dirty flag  */
    setDirtyFlag() {
        this.isDirty = true;
    }

    submitted() {
        this.isDirty = false;
    }


    /** set the menu on menu change */
    setMenu(key) {
        this.$emit('menuChanged', key);
    }


}

